import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CheckoutService } from 'src/app/services/checkout.service';
import { InfoCardComponent } from '../../shared/info-card/info-card.component';
import { IPayPalConfig } from 'ngx-paypal';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';
import { WaitingPayComponent } from '../waiting-pay/waiting-pay.component';
import { AppSettings } from 'src/app/app-settings';
import { ConfirmPayComponent } from '../confirm-pay/confirm-pay.component';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from 'src/app/services/user.service';
import { ApiSalesService } from 'src/app/services/api-sales.service';

@Component({
  selector: 'app-step-checkout',
  templateUrl: './step-checkout.component.html',
  styleUrls: ['./step-checkout.component.scss']
})
export class StepCheckoutComponent implements OnInit, OnDestroy {

  public payPalConfig?: IPayPalConfig;
  lineProducts: any[] = [];

  optionPayment: string = 'card';
  optionsYear: any[] = [];
  dataCard?: any;
  tickets: any[];

  @Input() redirectPaylandsUri: any = '';
  redirectPaylands: any;

  @Input() dataBuy!: any;
  @Output() sendPayment: EventEmitter<any> = new EventEmitter<any>();
  message: string = '';
  waiting: boolean = false;
  isAdmin: boolean = false;

  stripe = require('stripe')(AppSettings.KEYS.stripe);
  openResumeResponsive: boolean = false;
  disabledButton: boolean = false;
  @Input() stepPayOpen: boolean = false;
  order!: any;

  cardsUser: any[] = [];

  constructor(private checkoutService: CheckoutService, private formBuilder: FormBuilder,
    private dialog: MatDialog, private auth: AuthenticationService, private userService: UserService,
    private router: Router, private sanitizer: DomSanitizer, private apiSales: ApiSalesService) { }

  ngOnInit() {
    let profile = this.auth.getProfile();
    this.isAdmin = profile?.roleFunctions?.length > 0;
    this.dataCard = this.dataBuy;
    this.order = this.dataBuy?.order.order;
    this.generateArrayOfYears();

    // Obtener las tarjetas guardadas del usuario
    this.userService.getSavedCardsUser().subscribe({
      next: (data) => {
        this.cardsUser = data['data'];
        if (this.cardsUser?.length > 0) {
          this.optionPayment = this.cardsUser[0].id;
        }
      }
    })

    this.apiSales.openedPurchase.subscribe({
      next: (data) => {
        this.disabledButton = data;
      }
    });
    this.redirectPaylands = this.sanitizer.bypassSecurityTrustResourceUrl(this.redirectPaylandsUri);
  }

  generateArrayOfYears() {
    var min = new Date().getFullYear();
    var max = min + 15;
    this.optionsYear = [];

    for (var i = min; i <= max; i++) {
      this.optionsYear.push(i)
    }
  }

  infoPrintTickets(idOdoo?: any) {
    if (idOdoo) {
      const dialogRef = this.dialog.open(ConfirmPayComponent, {
        panelClass: 'info-dialog',
        data: {
          idOdoo: idOdoo
        }
      });
      dialogRef.afterClosed().subscribe({
        next: (data) => {
          if (data.print) {
            let url = !this.isAdmin ? '/profile' : '/panel-control/orders/list';
            this.router.navigate([url]).then(() => {
              let text = 'Se han descargado las entradas correctamente.';
              this.infoCorrectPay('Se han descargado las entradas correctamente.', true);
            });
          } else {
            this.infoCorrectPay('El pago se ha realizado correctamente. Podrás consultar las entradas en tu correo electrónico o en el apartado Mis compras de tu perfil.', true);
          }
        }
      })
    } else {
      this.infoCorrectPay('El pago se ha realizado correctamente. Podrás consultar las entradas en tu correo electrónico o el apartado Mis compras de tu perfil.', true);
    }
  }

  infoCorrectPay(msg: string, correct: boolean) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: false,
        text: msg,
        btnCancel: false
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res && correct) {
        this.router.navigate(['/profile']);
      }
    })
  }

  openWaitPayment(idPayment: any) {
    const dialogRef = this.dialog.open(WaitingPayComponent, {
      panelClass: 'info-dialog',
      data: {
        idPayment: idPayment,
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res && res == 'succeeded') {
        this.infoCorrectPay('El pago se ha realizado correctamente. Podrás consultar las entradas en tu correo electrónico o el apartado Mis compras de tu perfil.', true);
      } else {
        this.infoCorrectPay('Ha ocurrido un error al procesar el pago. Revisa los datos.', false);
        this.waiting = false;
      }
    })
  }

  payPaypalButton() {
    const iframe = document.getElementById("paylands") as HTMLIFrameElement;

    if (iframe) {
      // Enviar mensaje al iframe
      iframe.contentWindow.postMessage({ action: "submit" }, "*");
    }
  }

  stepPay() {
    if (!this.disabledButton) {
      this.disabledButton = true;
      const idCard = this.optionPayment != 'card' ? this.optionPayment : null;
      this.checkoutService.paymentByPaylands(this.order?.id, idCard).subscribe({
        next: (res) => {
          if (this.optionPayment == 'card') {
            this.dataBuy['card'] = true;
            this.dataBuy['stepPayOpen'] = true;
            this.dataBuy['redirectPaylands'] = res.data.redirect_url;
            this.router.navigate(['/checkout/payment/card'], { state: this.dataBuy });
            this.stepPayOpen = this.dataCard?.stepPayOpen;
            this.redirectPaylands = this.dataCard?.redirectPaylands;
            const auxString = JSON.stringify(this.dataBuy);
            localStorage.setItem('aux', auxString);
          }
          this.sendPayment.emit(true);
        }, error: (err) => {
          this.sendPayment.emit(false);
        }
      });
    }
  }

  ngOnDestroy() {
  }
}
